import React from 'react'
import { Link } from 'react-router-dom'

const HomePageSectionTwo = ({ authed }) => {
  return (
    <div className='container'>
      <div className='row align-items-center'>
        <div className='col-xl-5 col-lg-5 col-md-12  col-sm-12 col-xs-12'>
          <img
            className='img-fluid'
            title='Take a Look Inside Barnes and Noble'
            alt='Take a Look Inside Barnes and Noble'
            src='/img/inside-bn-eastchester-store-homepage-2.jpg'
          />
        </div>
        <div className='col-lg-7 col-md-12 col-sm-12'>
          <h3>
            <strong>Take a Look Inside Barnes &amp; Noble</strong>
          </h3>
          <p>
            We are committed to helping our employees learn and grow. Like your
            favorite book that features a great cast of characters, here,
            everyone plays a part in the development of our success story.
          </p>
          <Link
            className='btn btn-outline-dark'
            to={authed ? '/internal/inside-b-n' : '/inside-b-n'}
          >
            Learn more about us
          </Link>
        </div>
      </div>
      <br />
      <br />
      <br />
      <div className='row align-items-center'>
        <div className='col-lg-7 col-md-12 col-sm-12'>
          <h3>
            <strong>Discover Where You’d Like to Work</strong>
          </h3>
          <p>
            No matter where you live in the U.S., the likelihood is, there is a
            Barnes &amp; Noble nearby that would be a great fit for you. You
            love books! We are booklovers! Join a team filled with passionate
            booksellers who are just like you! We also hire for Corporate and
            Distribution Center positions in New York, New Jersey, and Nevada.
          </p>
          <Link className='btn btn-outline-dark' to={'/locations'}>
            More about our locations
          </Link>
        </div>
        <div className='col-xl-5 col-lg-5 col-md-12 col-sm-12 col-xs-12 align-middle'>
          <img
            title='Discover Where You’d Like to Work'
            alt='Discover Where You’d Like to Work'
            data-displaymode='Original'
            className='img-fluid'
            src='/img/BN_HRPhotos_4515.jpg'
          />
          <div className='spacer-div'>&nbsp;</div>
        </div>
      </div>
    </div>
  )
}

export default HomePageSectionTwo
